import {GroupEventBus} from "../../broadcast/group-event-bus";
import {inject} from "aurelia-framework";
import {eagerInstance} from "../../bootstrap/app-hooks";
import {get, defaults} from "lodash";
import {
  GroupService,
  isGroupDefault,
  defaultGroupId
} from "./group-service";
import {
  LeaveEvent,
  RemoveEvent,
  EditEvent,
  SelectEvent
} from "../../broadcast/group-events";

@eagerInstance()
@inject(GroupEventBus, GroupService)
export class CurrentGroup {

  __state;
  __statePromise

  get state() {
    return this.__state || {};
  }

  get data() {
    return get(this.__state, 'groupPath', []).find(o => o.id === this.__state.groupId) || {};
  }

  constructor(groupEventBus: GroupEventBus, private __groupService: GroupService) {
    let stateResolve;
    this.__statePromise = new Promise(resolve => stateResolve = resolve);

    groupEventBus.subscribe(EditEvent, msg => this.__handleEdit(msg), this);
    groupEventBus.subscribe(SelectEvent, msg => this.__handleSelect(msg), this);
    groupEventBus.subscribeGroup([LeaveEvent, RemoveEvent], msg => this.__handleRemove(msg), this);

    __groupService.defaultGroup().response.then(group => {
      return __groupService.withPath(group.id).then(path => {
        this.__handleSelect({groupId: group.id, groupPath: path});

        this.__statePromise = null;
        stateResolve();

        return __groupService.selectGroup({
          groupId: group.id, caller: this, path: path
        });
      });
    });
  }

  onReady() {
    return this.__statePromise ? this.__statePromise : Promise.resolve();
  }

  is(groupId) {
    return this.state.groupId !== undefined && this.state.groupId === groupId;
  }

  not(groupId) {
    return !this.is(groupId);
  }

  __handleEdit({groupId, data}) {
    this.__pathAffected(groupId, (index, path) => {
      path[index] = data;
      this.__updateState(defaults({
        groupPath: path
      }, this.__state));
    });
  }

  __handleSelect({groupId, groupPath}) {
    this.__updateState(defaults({
      groupId, groupPath
    }, this.__state));
  }

  __handleRemove({groupId}) {
    this.__pathAffected(groupId, (index, path) => {
      path = path.slice(0, index);
      groupId = get(path, `${path.length - 1}.id`, defaultGroupId.PUBLIC);

      if (!isGroupDefault(groupId)) {
        this.__updateState(defaults({
          groupId, groupPath: path
        }, this.__state));
        this.__groupService.selectGroup({groupId, path, caller: this});
      } else {
        this.__groupService.selectGroup({groupId});
      }
    });
  }

  __pathAffected(groupId, consumer) {
    let path = get(this.__state, 'groupPath', []);
    let index = path.findIndex(g => g.id === groupId);
    if (index > -1) {
      consumer(index, path);
    }
  }

  __updateState(state) {
    Object.freeze(state);
    this.__state = state;
  }

}
